/** @format */

import React, { useState, useCallback, useMemo } from "react";
import uniq from "lodash.uniq";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";
import { capitalCase } from "text-capital-case";

import List from "./List";
import Create from "./Create";
import SurveyFilter from "./SurveyFilter";
import { getRowsPerPage } from "../../utils/utils";
import useGetAllSurvey from "./hooks/useGetAllSurvey";
import AccordionLoader from "../common/AccordionLoader";

import "primeflex/primeflex.css";
import "../../style/news.css";

const Survey = (props) => {
  let [surveyFilter, setSurveyFilter] = useState({
    surveyName: [],
    status: [],
  });
  let [showAdd, setShowAdd] = useState(false);
  let [page, setPage] = useState({
    first: 0,
    rows: 5,
  });
  const onPageChange = (event) => {
    setPage({
      first: event.first,
      rows: event.rows,
    });
  };

  const { data, isLoading, isSuccess } = useGetAllSurvey();

  let addSurveyHandler = useCallback(() => {
    setShowAdd(true);
  }, [setShowAdd]);
  let discardSurveyHandler = useCallback(() => {
    setShowAdd(false);
  }, [setShowAdd]);

  let onFilterChangeHandler = useCallback((name, value) => {
    setSurveyFilter((prevFilter) => ({
      ...prevFilter,
      [name]: value,
    }));
  }, []);

  let SURVEY_OPTIONS = useMemo(() => {
    if (data === undefined) {
      return {
        surveyNames: [],
        surveyStatuses: [],
      };
    }
    let surveyStatus = uniq(data.map((data) => capitalCase(data.status)));
    return {
      surveyNames: data.map((data) => ({
        label: data.title,
        value: data.title,
      })),
      surveyStatuses: surveyStatus.map((data) => ({
        label: data,
        value: data,
      })),
    };
  }, [data]);

  let { first, rows } = page;
  
  let FILTERED_LIST_DATE = useMemo(() => {
    let filtered_list = [];
    let { status, surveyName } = surveyFilter;

    if (data === undefined) return filtered_list;

    if (status.length === 0 && surveyName.length === 0) return data;
    data.forEach((data) => {
      if (status.includes(capitalCase(data.status)) || surveyName.includes(data.title)) {
        filtered_list.push(data);
      }
    });
    return filtered_list;
  }, [surveyFilter, data]);

  let PAGE_DATA = useMemo(() => FILTERED_LIST_DATE.slice(first, first + rows + 1), [FILTERED_LIST_DATE, first, rows]);
  return (
    <>
      <div className='flex flex-row grid p-fluid'>
        <SurveyFilter
          surveyNames={SURVEY_OPTIONS.surveyNames}
          surveyStatuses={SURVEY_OPTIONS.surveyStatuses}
          surveyName={surveyFilter.surveyName}
          status={surveyFilter.status}
          onFilterChangeHandler={onFilterChangeHandler}
        />
        <div className='mt-2 col-3 md:col-3 col-offset-3'>
          <Button onClick={addSurveyHandler} label='Add Survey' className='btn3 mt-3' />
        </div>
      </div>
      {isLoading ? <AccordionLoader /> : null}
      {isSuccess && data.length > 0 ? 
      <>
        <List list={PAGE_DATA} />
        <Paginator
          className="flex-1 print-hidden"
          first={first}
          rows={rows}
          totalRecords={FILTERED_LIST_DATE.length}
          onPageChange={onPageChange}
          rowsPerPageOptions={getRowsPerPage(data, 5)}
          template='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
          currentPageReportTemplate='Showing {first} to {last} of {totalRecords}'
        />
      </> : null}
      <Dialog
        baseZIndex={10001}
        header={null}
        showHeader={false}
        visible={showAdd}
        style={{ width: "35vw" }}
        onHide={() => {}}
        focusOnShow={false}
        className='mi__dialog'
        id='dialog__add__survey'
      >
        <Create discardSurveyHandler={discardSurveyHandler} />
      </Dialog>
    </>
  );
};
export default Survey;
